module.exports = __webpack_public_path__ + "static/img/storageConstruct.25330218.png";